// FeedbackContext — lets deeply-nested panels (e.g. an ErrorBoundary fallback)
// reach App.tsx's `handleOpenFeedback` without prop drilling.

import { createContext, useContext } from 'react';
import type { UserFeedback } from '../../utils/userFeedback';

export type OpenFeedbackFn = (
  type?: UserFeedback['type'],
  category?: string,
  error?: string,
) => void;

export const FeedbackContext = createContext<OpenFeedbackFn | null>(null);

export function useFeedbackOpener(): OpenFeedbackFn | null {
  return useContext(FeedbackContext);
}
